import { render } from "./Us.vue?vue&type=template&id=f56a06f2"
import script from "./Us.vue?vue&type=script&lang=js"
export * from "./Us.vue?vue&type=script&lang=js"

import "./Us.vue?vue&type=style&index=0&id=f56a06f2&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__